import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
// import LandingPage from "./pages/LandingBackup";

const App = () => (
  <Router> {/* Remove the basename as it's no longer needed */}
    <Routes>
      <Route path="/" element={<LandingPage />} />
    </Routes>
  </Router>
);

export default App;